import * as THREE from "three";
import Geometry from "./geometry";

// Base das formas 3D definidas pela caixa largura x altura x profundidade centrada em (x, y, z).
// As dimensões e a orientação seguem a malha gerada pelo Gmsh (module-3d/gmsh), para a cena
// desenhada ser a mesma geometria simulada.
export default class SolidGeometry extends Geometry {
  constructor(shape, color, geometry, positions) {
    const material = new THREE.MeshPhongMaterial({
      ...color,
      transparent: true,
      side: THREE.DoubleSide
    });
    const mesh = new THREE.Mesh(geometry, material);

    super(geometry, material, mesh, shape);
    this.setPositions(positions.x, positions.y, positions.z);
  }
}

// Polígono no plano xy (vértices relativos ao centro) extrudado em z e centrado
export function prismGeometry(vertices, depth) {
  const shape = new THREE.Shape();
  vertices.forEach(([vx, vy], index) =>
    index === 0 ? shape.moveTo(vx, vy) : shape.lineTo(vx, vy)
  );
  shape.closePath();

  const geometry = new THREE.ExtrudeGeometry(shape, { depth, bevelEnabled: false });
  geometry.translate(0, 0, -depth / 2);
  return geometry;
}
